import MapControl from 'client/pages/MapPage/components/MapControl/MapControl';
import styles from './MyLocation.module.scss';
import MyLocationButton from 'client/components/MyLocationButton/MyLocationButton';

export const MyLocation = () => {
    return <MapControl>
        <div className={styles.container}>
            <MyLocationButton/>
        </div>
    </MapControl>;
};

export default MyLocation;
